import { Box } from '@churni/styleguide';
import * as React from 'react';
import LogoWhiteSVG from './assets/logo-white.svg';

export function LogoWhite(props: any): React.ReactElement {
  return <Box width={90} as={LogoWhiteSVG} {...props} />;
}
